const customer = {
	name: 'Tallgrass',

	emails: {
		pods: '',
		corrosion: ''
	}
};

export default customer;
